<template>
	<div class="detail-gallery">
		<div class="detail-gallery-view">
			<img
				:src="visibleImage"
				alt="imagen principal"
				class="detail-gallery-view-image"
			/>
		</div>
		<div class="detail-gallery-preview">
			<template v-for="image in images">
				<button
					class="detail-gallery-preview-item"
					:class="{ 'active' : image.visible }"
					:key="image.id"
					@click="$emit('select-image', image)"
				>
					<img
						:src="image.urlImage"
						alt=""
						class="detail-gallery-preview-item-image"
					/>
				</button>
			</template>
		</div>
	</div>
</template>

<script>
	function visibleImage() {
		return this.images.find(i => i.visible).urlImage;
	}

	export default {
		name: 'detail-gallery',
		computed: {
			visibleImage,
		},
		props: {
			images: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.detail-gallery {
		&-view {
			max-height: 407px;
			max-width: 407px;
			text-align: center;
			width: 100%;

			@media (min-width: 936px) {
				height: 407px;
			}

			&-image {
				max-height: 100%;
				max-width: 100%;
			}
		}

		&-preview {
			height: 124px;
			margin-top: 22px;
			max-width: 407px;
			overflow-x: hidden;
			width: 100%;

			@media (min-width: 936px) {
				margin-top: 62px;
			}

			&-item {
				border: 1px solid rgba(216, 216, 216, 0.64);
				border-radius: 5px;
				height: 118px;
				margin-right: 10px;
				width: 118px;

				&-image {
					max-height: 100%;
				}

				&.active {
					border: 2px solid color(newprimary);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/product-detail/detail-gallery.vue